import { AttachmentDto, CustomerReportClaimDto } from '@mca-feature';
import { BaseMapper } from '@shared/data';
import { v4 } from 'uuid';
import { ClaimType } from '../../../../../core/enum/claims/claim-type.enum';
import { AttachmentModel } from '../../../../../core/interface/attachment-model';
import { CustomerReportClaimModel } from '../../../../../core/interface/claims/customer-claims-model';

export class CustomerReportClaimMapper extends BaseMapper<CustomerReportClaimModel, CustomerReportClaimDto> {
    public mapDtoToModel(dto: CustomerReportClaimDto): CustomerReportClaimModel {
        return {
            uuid: v4(),
            claimType: ClaimType.ReportClaim,
            isCancelable: true,
            claimId: dto.reportClaimId,
            medifitClaimId: dto.medifitClaimId,
            status: dto.status,
            description: dto.description,
            submittedAt: this.stringDateToDayjs(dto.submittedAt),
            updatedAt: this.stringDateToDayjs(dto.updatedAt),
            contractorName: dto.contractorName,
            service: dto.service,
            visitDate: this.stringDateToDayjs(dto.visitDate),
            attachments: dto.attachments ? dto.attachments.map(this.mapAttachmentDtoToModel.bind(this)) : null,
            allowanceToken: dto.allowanceToken,
            isUsed: false,
        };
    }

    private mapAttachmentDtoToModel(dto: AttachmentDto): AttachmentModel {
        return {
            documentId: dto.documentId,
            name: dto.name,
            mimeType: dto.mimeType,
            medifitDocumentId: dto.medifitDocumentId,
            documentType: dto.documentType,
        };
    }
}
